export class DadosBancoADO {
    nR_BANCO: string;
    nR_AG_BANCO: string;
    nM_AGENCIA_BANCARIA: string;
    iC_ATIVO: string;
}